import { Grid } from "@mui/material"
import AppBar from "@mui/material/AppBar"
import Toolbar from "@mui/material/Toolbar"
import { makeStyles } from "tss-react/mui"
import { useAppSelector } from "../../modules/store/storeHooks"
import { UserType } from "../../modules/login/loginTypes"
import { selectEffectiveUserType } from "../../modules/context/contextSelectors"
import { ContextDisplay } from "../../modules/context/components/ContextDisplay"
import { AvatarMenu } from "./components/AvatarMenu"
import { LayoutContainer } from "./components/LayoutContainer"
import { drawerWidthCompact, drawerWidthNormal } from "./LeftBar"
import { AwaitingApprovalNavItem } from "./components/AwaitingApprovalNavItem"
import { MatchEnvironment } from "../../modules/environment/components/MatchEnvironment"
import { EnvironmentType } from "../../modules/environment/envTypes"
import { MatchActualUserType } from "../../modules/accessControl/MatchActualUserType"
import { InstructionButton } from "./components/supportInstructions/InstructionButton"
import { NotificationTopBarButton } from "./components/NotificationTopBar/NotificationTopBarButton"
import { QaEnvWarning } from "./components/QaEnvWarning"
import { MainTopBarNewButton } from "./components/MainTopBarNewButton"
import { useEnvironment } from "../../modules/environment/envHooks"

type StyleProps = Readonly<{
    compactNav: boolean
    topOffset: boolean
}>

const useStyles = makeStyles<StyleProps>()((_theme, { compactNav, topOffset }) => ({
    appBar: {
        //backgroundColor: theme.palette.common.black,
        top: topOffset ? "4rem" : 0,
    },
    toolbar: {
        paddingLeft: compactNav ? drawerWidthCompact : drawerWidthNormal,
    },
    toolbarRightArea: {
        gap: "1rem",
    },
}))

type TopBarWarningProps = Readonly<{
    compactNav: boolean
}>

export function TopBarWarning({ compactNav }: TopBarWarningProps) {
    const { classes } = useStyles({ compactNav, topOffset: false })

    return (
        <MatchEnvironment environments={[EnvironmentType.QA]}>
            <Toolbar className={classes.toolbar} disableGutters>
                <QaEnvWarning />
            </Toolbar>
        </MatchEnvironment>
    )
}

type TopBarProps = Readonly<{
    environmentRoutePath: string | undefined
    compactNav: boolean
}>

export function TopBar({ environmentRoutePath, compactNav }: TopBarProps) {
    const env = useEnvironment()
    const shouldOffsetTop = env.currentEnv.type === EnvironmentType.QA
    const { classes } = useStyles({ compactNav, topOffset: shouldOffsetTop })
    const userType = useAppSelector(selectEffectiveUserType)
    const isMerchantUser = userType === UserType.MERCHANT

    return (
        <AppBar position="sticky" color="inherit" elevation={2} className={classes.appBar}>
            <Toolbar className={classes.toolbar} disableGutters>
                <LayoutContainer>
                    <Grid container wrap="nowrap" justifyContent="space-between" alignItems="center">
                        <ContextDisplay />

                        <Grid
                            container
                            item
                            wrap="nowrap"
                            width="auto"
                            flexGrow={0}
                            alignItems="center"
                            className={classes.toolbarRightArea}
                        >
                            {isMerchantUser && (
                                <>
                                    <MainTopBarNewButton showDropdownMenu />
                                    <AwaitingApprovalNavItem />
                                </>
                            )}

                            <MatchActualUserType userTypes={[UserType.SUPPORT]}>
                                <InstructionButton />
                            </MatchActualUserType>

                            {isMerchantUser && <NotificationTopBarButton />}

                            <AvatarMenu urlPrefix={environmentRoutePath} />
                        </Grid>
                    </Grid>
                </LayoutContainer>
            </Toolbar>
        </AppBar>
    )
}
